export enum WizardMode {
  EDIT,
  STEPPER,
  VIEW,
  VIEW_EDITABLE,
}
